import { OrdersPage } from './orders.component';
import { connect } from 'react-redux';
import { fetchOrders } from "./../../api/order/orderAction";

const mapDispatchToProps = {
    fetchOrders
};

const mapStateToProps = state => ({
    isLoading: state.orderPage.isLoading,
    orders: state.orderPage.orders,
});

export const OrdersContainer = connect(mapStateToProps, mapDispatchToProps)(OrdersPage);